import PencilIcon from "@assets/icons/pencil.icon";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export interface TitleProps {
  title: string;
  subTitle: string;
}
const Title = (props: TitleProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ marginBottom: "35px" }} >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <PencilIcon sx={{ height: "20px", width: "20px" }} />
        <Typography
          variant="h3"
          color="text.primary"
          sx={{
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          {t(props.title)}
        </Typography>
      </Box>
      <Typography variant="subtitle1" color="text.hint">
        {t(props.subTitle)}
      </Typography>
    </Box>
  );
};
export default Title;
